import { css, cx, useTheme } from '@fable/theme'
import { CarouselControl, useCarouselController } from 'components/carousel'
import { SearchFilterList } from './SearchFilterList'

interface Props {
  filters: { id: string; name: string }[]
  loading?: boolean
}

export const SearchFilter = ({ filters, loading = false }: Props) => {
  const controller = useCarouselController()
  const { mediaQueries } = useTheme()
  const maxIdx = controller.instance?.track?.details?.maxIdx
  const isFirst = controller.currentSlide === 0
  const isLast = controller.currentSlide === maxIdx

  if (loading || !filters?.length) return null

  const controlStyles = css`
    display: none;
    width: 32px;
    height: 32px;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
    ${mediaQueries.mobileL} {
      display: flex;
    }
  `

  return (
    <div
      className={cx(
        css`
          position: relative;
          padding-left: 70px;
          padding-right: 28px;
          ${mediaQueries.mobileL} {
            overflow: hidden;
            padding-left: 52px;
            padding-right: 0;
          }
        `,
        'fade'
      )}
    >
      <HomeClubsFilterGradient left hidden={isFirst} />
      <CarouselControl
        controller={controller}
        className={cx(
          controlStyles,
          css`
            right: auto;
            left: 52px;
          `
        )}
        left
        hide
      />
      <SearchFilterList controller={controller} list={filters} />
      <CarouselControl controller={controller} className={controlStyles} hide />
      <HomeClubsFilterGradient hidden={isLast} />
    </div>
  )
}

const HomeClubsFilterGradient = ({
  left = false,
  hidden,
}: {
  left?: boolean
  hidden: boolean
}) => {
  const { motion, mediaQueries } = useTheme()

  return (
    <span
      className={css`
        display: none;
        width: 150px;
        height: 112px;
        background: linear-gradient(
          to ${left ? 'left' : 'right'},
          rgba(255, 255, 255, 0),
          rgba(255, 255, 255, 1)
        );
        position: absolute;
        right: ${left ? 'auto' : 0};
        left: ${left ? '28px' : 'auto'};
        top: 50%;
        transform: translateY(-50%);
        z-index: 1;
        pointer-events: none;
        opacity: ${hidden ? 0 : 1};
        ${motion.transition('opacity')};
        transition-delay: 0.2s;
        ${mediaQueries.mobileL} {
          display: block;
        }
      `}
    />
  )
}
